var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.895 18l3.744-4-3.744-4h-1.824l2.384 2.432c.288.288.656.656.96.944-.688-.016-.992-.016-1.312-.016H8.36v1.28h7.744c.32 0 .64 0 1.312-.016-.304.288-.672.608-.944.896l-2.4 2.48h1.824z"
  })));
}
export default SvgArrowRight;